import { createI18n } from 'vue-i18n';
import { SupportedLanguageEnum } from '@app/utils/enums';
import translationsEn from '../../../../lang/en.json';
import translationsEs from '../../../../lang/es.json';

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem('lang') || SupportedLanguageEnum.Default,
  fallbackLocale: SupportedLanguageEnum.English,
  messages: {
    [SupportedLanguageEnum.English]: translationsEn,
    [SupportedLanguageEnum.Spanish]: translationsEs
  }
});

export default i18n;
